import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1014",
  "use": "icon-1014-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-1014\" viewBox=\"0 0 16 16\" id=\"icon-1014\">\n  <path d=\"M6.932.993h5.411c.264 0 .423.292.279.514L9.643 5.118a.155.155 0 0 0 .13.24h3.134c.417 0 .632.498.346.802L3.99 16.001 6.196 8.42a.156.156 0 0 0-.149-.199H2.844a.475.475 0 0 1-.416-.706l4.007-6.23c.1-.18.29-.292.497-.292z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol